module.exports = __webpack_public_path__ + "img/sec-b.56a80f74.svg";